export default {"src":"/_next/static/media/e-mail_color.f717ac9d.svg","height":32,"width":32};